<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <h1>Informações do sócio</h1>
      <p>Agora, por favor, forneça alguns dados sobre você.</p>      
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
         <form @submit="onSubmit">
            <div class="form-group text-left">
              <label for="nomeCompleto">Nome</label>
              <input class="form-control form-control-lg" v-model="Nome" type="text" required disabled />
            </div>
            <div class="form-group text-left">
              <label>Cpf</label>
              <input class="form-control form-control-lg" v-model="Cpf" type="text" required v-mask="'cpf'"/>
            </div>
            <div class="text-center fixedOptions">
              <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>             
            </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from '@/utils/masker'

export default {
  data() {
    const solicitacao = this.currentUser
    return {
      Nome: solicitacao ? solicitacao.Social.NomeCompleto : null,   
      Cpf: solicitacao ? solicitacao.Social.Socio.Cpf : null,
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    validarCpf(strCPF) {
        var Soma;
        var Resto;
        Soma = 0;
        if (strCPF == "00000000000") return false;
        
        for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
        
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;
        
        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
        
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
        return true;
    },
    onSubmit(e) {
      e.preventDefault()

      if(this.validarCpf(Masker.unmaskCpf(this.Cpf))) {
        this.currentUser.Social.Socio.Cpf = Masker.unmaskCpf(this.Cpf)

        this.$emit('on-submit', {Social: this.currentUser.Social})
      } else {
        this.$Notify.error("O CPF não é valido, favor tentar novamente!");
      }
      
    }
  },
  created() {
    if(!this.currentUser) this.currentUser = {}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/InformacoesSocioStep.vue